import * as React from "react";
import * as ReactDOM from "react-dom";

import { ColumnProps } from './CellColumnProps';

export interface Props extends ColumnProps
{
    trueTitle?: string;
    falseTitle?: string;
    
    getValue: (item: any) => any;
}

// This column maps boolean flag to string
export class DataGridFlagValueColumn extends React.Component<Props, null>
{
    render ()
    {
        const { datum, getValue, trueTitle = 'Yes', falseTitle = 'No' } = this.props;
        const value = (getValue(datum) as boolean) ? trueTitle : falseTitle;
        return <td>{value}</td>;
    }
}



// WEBPACK FOOTER //
// ./src/components/DataGrid/DataGridFlagValueColumn.tsx